!(function () {
  "use strict";

  const selectors = {
    cartDrawer: "cart-drawer",
    tabs: "[data-cart-drawer-tabs]",
    tab: "[data-cart-drawer-tab]",
    panel: "[data-cart-drawer-panel]",
    confidence: ".drawer__empty__confidence--mobile",
    inlineQuickAddScope:
      ".drawer__inline-quick-add-scope, .product-grid-inline-quick-add-scope",
    gridItem: "[data-grid-item]",
    recentGrid: ".drawer__empty__recent",
    recentEmpty: "[data-recently-viewed-empty]",
    emptyMain: ".drawer__empty__main",
    inlineBtn: "[data-inline-quick-add-handle]",
    siblingSwapper: "[data-sibling-swapper]",
    holder: "[data-quick-add-holder]",
    inlineSlot: "[data-inline-quick-add]",
    apiContent: "[data-api-content]",
    formInner: ".product-quick-add__form__inner",
    cardImage:
      ".product-upsell__image__thumb img, .product-upsell__image__thumb .image__img",
    cardTitle: ".product-upsell__title",
    cardPrice: ".product-upsell__price .new-price, .product-upsell__price",
    apiTitle: ".product__title",
    apiPrice: "[data-product-price], .product__price .price",
    apiImage: ".product-quick-add__images img, .product__photo img",
  };

  const classes = {
    active: "is-active",
    loading: "is-loading",
    expanded: "is-inline-expanded",
  };

  const attributes = {
    inlineHandle: "data-inline-quick-add-handle",
    modalHandle: "data-quick-add-modal-handle",
  };

  function getInlineScope(element) {
    return element?.closest(selectors.inlineQuickAddScope);
  }

  function getRecentPanel(drawer) {
    return drawer.querySelector("[data-cart-drawer-shared-recent]");
  }

  function getRecentGrid(drawer) {
    const panel = getRecentPanel(drawer);
    return panel?.querySelector(selectors.recentGrid) || null;
  }

  function getRecentEmptyMessage(drawer) {
    const panel = getRecentPanel(drawer);
    return panel?.querySelector(selectors.recentEmpty) || null;
  }

  function setTabState(drawer, target) {
    const confidence = drawer.querySelector(selectors.confidence);
    const emptyMain = drawer.querySelector(selectors.emptyMain);
    const sharedRecent = drawer.querySelector(
      "[data-cart-drawer-shared-recent]",
    );
    const foot = drawer.querySelector(".drawer__foot");
    const isRecent = target === "recently-viewed";

    drawer.classList.toggle("is-recent-tab", isRecent);

    if (confidence) {
      confidence.hidden = isRecent;
    }

    if (emptyMain) {
      emptyMain.classList.toggle("is-recent-tab", isRecent);
    }

    if (sharedRecent) {
      sharedRecent.classList.toggle("is-recent-tab", isRecent);
      sharedRecent.hidden = !isRecent;
    }

    drawer
      .querySelectorAll(
        ".drawer__body > .cart-block:not(.drawer__head):not(.cart-block--free-shipping)",
      )
      .forEach((block) => {
        block.hidden = isRecent;
      });

    const freeShipping = drawer.querySelector(".cart-block--free-shipping");
    if (freeShipping) {
      freeShipping.hidden = false;
    }

    if (foot && !drawer.classList.contains("is-empty")) {
      foot.hidden = isRecent;
    }
  }

  function syncRecentTabBlocks(drawer) {
    if (!drawer?.classList.contains("has-drawer-tabs")) return;

    const isRecent =
      drawer.classList.contains("is-recent-tab") ||
      Boolean(drawer.querySelector(".drawer__shared-recent.is-recent-tab"));

    setTabState(drawer, isRecent ? "recently-viewed" : "cart");
  }

  function applyQuickAddLabels(drawer) {
    const recent = getRecentGrid(drawer);
    if (!recent) return;

    const label = recent.getAttribute("data-quick-add-label");
    if (!label) return;

    recent.querySelectorAll(".product-upsell__btn .btn__text").forEach((el) => {
      el.textContent = label;
    });
  }

  function updateRecentEmptyState(drawer) {
    const recent = getRecentGrid(drawer);
    const emptyMsg = getRecentEmptyMessage(drawer);
    if (!recent || !emptyMsg) return;

    const hasProducts = recent.children.length > 0;
    recent.classList.toggle("hidden", !hasProducts);
    emptyMsg.classList.toggle("hidden", hasProducts);
  }

  function initTabs(drawer) {
    const tabsRoot = drawer.querySelector(selectors.tabs);
    if (!tabsRoot) return;

    const tabs = tabsRoot.querySelectorAll(selectors.tab);
    const panels = drawer.querySelectorAll(selectors.panel);

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const target = tab.getAttribute("data-cart-drawer-tab");
        if (!target) return;

        tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle(classes.active, isActive);
          item.setAttribute("aria-selected", isActive ? "true" : "false");
        });

        panels.forEach((panel) => {
          const panelTarget = panel.getAttribute("data-cart-drawer-panel");
          const isActive = panelTarget === target;

          if (panelTarget === "recently-viewed") {
            panel.classList.toggle(classes.active, isActive);
            panel.hidden = !isActive;
            return;
          }

          if (panelTarget === "cart" && drawer.classList.contains("is-empty")) {
            panel.classList.toggle(classes.active, isActive);
            panel.hidden = !isActive;
          }
        });

        setTabState(drawer, target);

        if (target === "recently-viewed") {
          updateRecentEmptyState(drawer);
          applyQuickAddLabels(drawer);
        }
      });
    });

    drawer.addEventListener("theme:recently-viewed:loaded", () => {
      updateRecentEmptyState(drawer);
      applyQuickAddLabels(drawer);
    });

    setTabState(drawer, "cart");
  }

  function getRoot() {
    return window.theme?.routes?.root || "/";
  }

  function fetchUpsellHtml(handle, variantId) {
    const root = getRoot();
    const params = new URLSearchParams({ section_id: "api-product-upsell" });
    if (variantId) params.set("variant", String(variantId));
    const url = `${root}products/${handle}?${params.toString()}`;

    return fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error("Failed to load product");
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        const apiContent = doc.querySelector(selectors.apiContent);
        return apiContent ? apiContent.innerHTML : "";
      });
  }

  function isProductGridScope(holder) {
    return holder?.classList.contains("product-grid-inline-quick-add-scope");
  }

  function normalizeImageUrl(url) {
    if (!url) return "";

    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.pathname;
    } catch {
      return String(url).split("?")[0];
    }
  }

  function imageFileKey(url) {
    const normalized = normalizeImageUrl(url);
    const parts = normalized.split("/");
    return parts[parts.length - 1] || normalized;
  }

  function escapeAttr(value) {
    if (typeof CSS !== "undefined" && CSS.escape) return CSS.escape(value);
    return String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }

  function resolveFeaturedSrc(featured) {
    if (!featured) return "";
    let src = featured.src || featured;
    if (typeof src !== "string") return "";
    if (src.startsWith("//")) src = `${window.location.protocol}${src}`;
    return src;
  }

  function applySrcToImg(img, src, srcset) {
    if (!img || !src) return;
    img.src = src;
    if (srcset) {
      img.setAttribute("srcset", srcset);
    } else {
      img.removeAttribute("srcset");
    }
  }

  function applyImageToImg(targetImg, sourceImg) {
    if (!targetImg || !sourceImg) return;
    const nextSrc = sourceImg.currentSrc || sourceImg.src;
    if (!nextSrc) return;
    applySrcToImg(targetImg, nextSrc, sourceImg.getAttribute("srcset"));
  }

  function getHoverSliderContext(productItem) {
    const hoverImages = productItem.querySelector("hover-images");
    const slider = productItem.querySelector("[data-hover-slider]");
    if (!slider) return null;

    return {
      hoverImages,
      slider,
      slides: Array.from(slider.querySelectorAll(".product-item__bg__slide")),
    };
  }

  function goToHoverSlide(context, index) {
    const slide = context.slides[index];
    if (!slide) return false;

    const flickity = context.hoverImages?.flkty;

    if (flickity?.isActive && flickity.cells?.length) {
      const cellIndex = flickity.cells.findIndex(
        (cell) => cell.element === slide,
      );

      if (cellIndex >= 0) {
        flickity.select(cellIndex);
        return true;
      }

      return false;
    }

    const slideWidth = context.slider.clientWidth || slide.offsetWidth || 1;
    context.slider.scrollTo({
      left: index * slideWidth,
      behavior: "smooth",
    });

    if (context.hoverImages) {
      context.hoverImages.style.setProperty("--slider-index", String(index));
    }

    return true;
  }

  function getVariantImageSrc(variant) {
    if (!variant) return "";

    if (variant.featured_image?.src) {
      return resolveFeaturedSrc(variant.featured_image);
    }

    if (variant.featured_media?.preview_image?.src) {
      return resolveFeaturedSrc(variant.featured_media.preview_image);
    }

    if (typeof variant.featured_image === "string") {
      return resolveFeaturedSrc(variant.featured_image);
    }

    return "";
  }

  function getActiveHoverSlideImage(context) {
    if (!context) return null;

    const { slider, slides, hoverImages } = context;
    const flickitySelected = slider.querySelector(
      ".flickity-cell.is-selected img",
    );
    if (flickitySelected) return flickitySelected;

    const slideWidth = slider.clientWidth || 1;
    const index = Math.min(
      slides.length - 1,
      Math.max(0, Math.round(slider.scrollLeft / slideWidth)),
    );

    return (
      slides[index]?.querySelector("img") || slides[0]?.querySelector("img")
    );
  }

  function readableImageSrc(img) {
    if (!img) return "";
    const attr = img.getAttribute("src") || "";
    const current = img.currentSrc || img.src || "";
    const src = attr && !attr.includes("blank.svg") ? attr : current;
    if (!src || src.includes("blank.svg")) return "";
    return src;
  }

  function imagesShareFile(left, right) {
    if (!left || !right) return false;
    return (
      imageFileKey(left) === imageFileKey(right) ||
      normalizeImageUrl(left) === normalizeImageUrl(right)
    );
  }

  function innerOptionValues(inner) {
    const raw = inner.getAttribute("data-variant-options");
    if (raw) {
      return raw
        .split("||")
        .map((part) => part.trim())
        .filter(Boolean);
    }

    return (inner.getAttribute("data-variant-title") || "")
      .split(" / ")
      .map((part) => part.trim())
      .filter(Boolean);
  }

  function syncHoverSliderToSrc(productItem, src, sourceImg, colorValue) {
    const context = getHoverSliderContext(productItem);
    if (!context || !src) return false;

    let targetIndex = context.slides.findIndex((slide) => {
      const img = slide.querySelector("img");
      return imagesShareFile(readableImageSrc(img), src);
    });

    if (targetIndex < 0 && colorValue) {
      const needle = String(colorValue).trim().toLowerCase();
      const handle = needle.replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

      targetIndex = context.slides.findIndex((slide) => {
        const img = slide.querySelector("img");
        if (!img || !needle) return false;
        const alt = (img.getAttribute("alt") || "").toLowerCase();
        const file = imageFileKey(readableImageSrc(img)).toLowerCase();
        return alt.includes(needle) || (handle && file.includes(handle));
      });
    }

    if (targetIndex >= 0 && goToHoverSlide(context, targetIndex)) {
      return true;
    }

    const activeImg = getActiveHoverSlideImage(context);
    if (!activeImg) return false;

    if (sourceImg) {
      applyImageToImg(activeImg, sourceImg);
    } else {
      applySrcToImg(activeImg, src);
    }

    return true;
  }

  function findVariantImageInner(productImage, variant, colorValue) {
    if (!productImage || !variant) return null;

    const inners = Array.from(
      productImage.querySelectorAll("[data-variant-title]"),
    );
    const featuredId = String(
      variant.featured_media?.preview_image?.id ||
        variant.featured_image?.id ||
        "",
    );

    if (featuredId) {
      const byKey = inners.find(
        (inner) => inner.getAttribute("data-variant-image-key") === featuredId,
      );
      if (byKey) return byKey;
    }

    const options = (variant.options || []).filter(Boolean);
    let best = null;
    let bestScore = 0;

    inners.forEach((inner) => {
      const parts = innerOptionValues(inner);
      const title = inner.getAttribute("data-variant-title") || "";
      let score = 0;

      if (variant.title && title === variant.title) {
        score = 100;
      } else {
        options.forEach((option) => {
          if (parts.includes(option)) score += 1;
        });
        if (options[0] && parts[0] === options[0]) score += 0.5;
      }

      if (colorValue && parts.includes(colorValue)) score += 3;

      if (score > bestScore) {
        bestScore = score;
        best = inner;
      }
    });

    if (colorValue) {
      const colorMatch = inners.find((inner) =>
        innerOptionValues(inner).includes(colorValue),
      );
      if (
        colorMatch &&
        (!best || !innerOptionValues(best).includes(colorValue))
      ) {
        return colorMatch;
      }
    }

    return bestScore > 0 ? best : null;
  }

  function getCardPhoto(productImage) {
    const bg = productImage.querySelector("[data-product-image-default]");
    if (!bg) return null;

    return (
      bg.querySelector(":scope > figure img") ||
      bg.querySelector(":scope > .image-wrapper img")
    );
  }

  function getCheckedColorValue(holder) {
    const input = holder?.querySelector(
      ".radio__fieldset--swatches [data-single-option-selector]:checked",
    );
    return input?.value || "";
  }

  function getSelectedVariantFromHolder(holder) {
    const jsonEl = holder.querySelector("[data-product-json]");
    if (!jsonEl) return null;

    let product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch {
      return null;
    }

    if (!product?.variants?.length) return null;

    const selectedOptions = [];
    holder
      .querySelectorAll("[data-single-option-selector]")
      .forEach((input) => {
        if (!input.checked) return;

        const indexAttr = input.getAttribute("data-index") || "";
        const match = indexAttr.match(/option(\d+)/i);
        if (!match) return;

        selectedOptions[parseInt(match[1], 10) - 1] = input.value;
      });

    if (!selectedOptions.length) return null;

    const exactMatch = product.variants.find((variant) =>
      variant.options.every(
        (option, index) => option === selectedOptions[index],
      ),
    );
    if (exactMatch) return exactMatch;

    const selectedIndexes = selectedOptions
      .map((value, index) => (value !== undefined ? index : -1))
      .filter((index) => index >= 0);

    if (!selectedIndexes.length) return null;

    return product.variants.find((variant) =>
      selectedIndexes.every(
        (index) => variant.options[index] === selectedOptions[index],
      ),
    );
  }

  function updateGridItemImage(gridItem, variant, colorValue) {
    if (!gridItem || !variant) return;
    if (!window.matchMedia("(max-width: 749px)").matches) return;

    const productImage = gridItem.querySelector("[data-product-image]");
    if (!productImage) return;

    const selectedInner = findVariantImageInner(
      productImage,
      variant,
      colorValue,
    );
    const selectedImg = selectedInner?.querySelector("img");
    const nextSrc =
      readableImageSrc(selectedImg) || getVariantImageSrc(variant);

    const cardPhoto = getCardPhoto(productImage);
    if (cardPhoto && selectedImg && cardPhoto !== selectedImg) {
      applyImageToImg(cardPhoto, selectedImg);
    } else if (cardPhoto && nextSrc) {
      applySrcToImg(cardPhoto, nextSrc);
    }

    if (nextSrc) {
      syncHoverSliderToSrc(gridItem, nextSrc, selectedImg, colorValue);
    }
  }

  function syncCardMeta(holder, html) {
    const temp = document.createElement("div");
    temp.innerHTML = html;

    if (isProductGridScope(holder)) {
      const gridItem = holder.closest(selectors.gridItem);
      if (!gridItem) return;

      const titleEl = gridItem.querySelector(".product-item__title");
      const apiTitle = temp.querySelector(selectors.apiTitle);
      if (titleEl && apiTitle) {
        titleEl.textContent = apiTitle.textContent.trim();
      }

      const priceEl = gridItem.querySelector("[data-product-price]");
      const apiPrice =
        temp.querySelector("[data-product-price]") ||
        temp.querySelector(".product__price .price__current, .product__price");
      if (priceEl && apiPrice) {
        priceEl.innerHTML = apiPrice.innerHTML;
      }

      const cardImg = gridItem.querySelector(
        "[data-product-image-default] img, .product-item__bg img",
      );
      const apiImg = temp.querySelector(selectors.apiImage);
      if (cardImg && apiImg) {
        applyImageToImg(cardImg, apiImg);
        const nextSrc = apiImg.currentSrc || apiImg.src;
        if (nextSrc) {
          syncHoverSliderToSrc(gridItem, nextSrc, apiImg);
        }
      }

      return;
    }

    const titleEl = holder.querySelector(selectors.cardTitle);
    const apiTitle = temp.querySelector(selectors.apiTitle);
    if (titleEl && apiTitle) {
      titleEl.textContent = apiTitle.textContent.trim();
    }

    const priceEl =
      holder.querySelector(".product-upsell__price .new-price") ||
      holder.querySelector(selectors.cardPrice);
    const apiPrice =
      temp.querySelector("[data-product-price]") ||
      temp.querySelector(".product__price .price__current, .product__price");
    if (priceEl && apiPrice) {
      priceEl.innerHTML = apiPrice.innerHTML;
    }

    const cardImg = holder.querySelector(selectors.cardImage);
    const apiImg = temp.querySelector(selectors.apiImage);
    if (cardImg && apiImg) {
      applyImageToImg(cardImg, apiImg);
    }
  }

  function setLoading(button, isLoading) {
    if (!button) return;
    button.classList.toggle(classes.loading, isLoading);
    button.disabled = isLoading;
  }

  function updateSizeLabels(root) {
    if (!root) return;

    root
      .querySelectorAll(".selector-wrapper--size[data-size-label-map]")
      .forEach((wrapper) => {
        const label = wrapper.querySelector("[data-option-value]");
        if (!label) return;

        try {
          const map = JSON.parse(wrapper.getAttribute("data-size-label-map"));
          const raw = label.textContent.trim();
          if (map[raw]) {
            label.textContent = map[raw];
          }
        } catch (error) {
          // Ignore malformed maps from injected markup.
        }
      });
  }

  function collapseInline(holder) {
    const isExpanded = holder?.classList.contains(classes.expanded);
    const isLoading = holder?.classList.contains(classes.loading);

    if (!isExpanded && !isLoading) return;

    const slot = holder.querySelector(selectors.inlineSlot);
    if (slot) {
      slot.innerHTML = "";
      slot.hidden = true;
    }

    holder.classList.remove(classes.expanded, classes.loading);
  }

  function collapseAllExcept(keepHolder) {
    document
      .querySelectorAll(`${selectors.holder}.${classes.expanded}`)
      .forEach((holder) => {
        if (holder === keepHolder) return;
        collapseInline(holder);
      });
  }

  function prepareInlineHtml(html) {
    const temp = document.createElement("div");
    temp.innerHTML = html;

    temp
      .querySelectorAll(
        [
          ".product-quick-add__images",
          "product-images",
          ".product__head",
          ".product__title__wrapper",
          ".product__block:has(.product__price__wrap)",
          ".product__block:has([data-price-wrapper])",
          ".product-quick-add__description",
          ".product__block--description",
          ".product-soldout-notification",
          ".shopify-payment-button",
          "noscript",
        ].join(","),
      )
      .forEach((el) => el.remove());

    const json = temp.querySelector("[data-product-json]");
    if (json) temp.prepend(json);

    return temp.innerHTML;
  }

  function getPreferredVariantId(holder) {
    const gridItem = holder?.closest(selectors.gridItem);
    if (!gridItem) return "";

    const pendingId = gridItem.getAttribute("data-selected-variant-id");
    if (pendingId) return pendingId;

    const currentSwatch = gridItem.querySelector(
      "[data-variant-image-swatch].product-item__variant-image-swatch--current",
    );

    return currentSwatch?.getAttribute("data-variant-id") || "";
  }

  function expandInline(holder, handle, triggerBtn) {
    const slot = holder.querySelector(selectors.inlineSlot);
    if (!slot || !handle) return;

    collapseAllExcept(holder);
    setLoading(triggerBtn, true);
    holder.classList.add(classes.loading);

    const variantId = getPreferredVariantId(holder);

    fetchUpsellHtml(handle, variantId)
      .then((html) => {
        if (!html) throw new Error("Empty product markup");

        syncCardMeta(holder, html);

        // product-form looks for closest [data-quick-add-modal] as its container
        slot.innerHTML = "";
        const formShell = document.createElement("div");
        formShell.className = "product-upsell__inline-form";
        formShell.setAttribute("data-quick-add-modal", "");
        formShell.setAttribute("data-product-upsell-ajax", "");
        formShell.setAttribute("data-section-type", "inline-quick-add");
        formShell.setAttribute("data-section-id", `inline-${handle}`);
        formShell.style.setProperty(
          "--swatch-size",
          "var(--swatch-size-product, 28px)",
        );
        formShell.innerHTML = prepareInlineHtml(html);
        slot.appendChild(formShell);
        slot.hidden = false;

        holder.classList.add(classes.expanded);
        holder.classList.remove(classes.loading);
        setLoading(triggerBtn, false);

        requestAnimationFrame(() => {
          slot.querySelectorAll("[data-animation]").forEach((item) => {
            item.classList.add("is-animated");
          });
          updateSizeLabels(slot);
          // product-form may overwrite labels on connect; remap after it settles
          setTimeout(() => updateSizeLabels(slot), 50);
          setTimeout(() => updateSizeLabels(slot), 200);

          holder.dispatchEvent(
            new CustomEvent("theme:inline-quick-add:expanded", {
              bubbles: true,
              detail: { holder },
            }),
          );
          setTimeout(() => {
            holder.dispatchEvent(
              new CustomEvent("theme:inline-quick-add:expanded", {
                bubbles: true,
                detail: { holder },
              }),
            );
          }, 120);

          const inlineScope = getInlineScope(holder);
          if (inlineScope?.classList.contains("drawer__empty__recent")) {
            holder.scrollIntoView({ block: "nearest", behavior: "smooth" });
          } else if (isProductGridScope(holder)) {
            holder
              .closest(selectors.gridItem)
              ?.scrollIntoView({ block: "nearest", behavior: "smooth" });
          }
        });
      })
      .catch(() => {
        holder.classList.remove(classes.loading);
        setLoading(triggerBtn, false);
      });
  }

  function onInlineQuickAddClick(event) {
    const button = event.target.closest(selectors.inlineBtn);
    if (!button) return;

    if (!getInlineScope(button)) return;

    event.preventDefault();
    event.stopPropagation();

    const holder = button.closest(selectors.holder);
    const handle = button.getAttribute(attributes.inlineHandle);
    if (!holder || !handle) return;

    if (holder.classList.contains(classes.expanded)) return;

    expandInline(holder, handle, button);
  }

  function onSiblingSwapClick(event) {
    const sibling = event.target.closest(selectors.siblingSwapper);
    if (!sibling) return;

    const holder = sibling.closest(`${selectors.holder}.${classes.expanded}`);
    if (!holder || !getInlineScope(holder)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (sibling.classList.contains("sibling__link--current")) return;

    const handle = sibling.getAttribute(attributes.modalHandle);
    if (!handle) return;

    expandInline(holder, handle, sibling);
  }

  function onOutsideClick(event) {
    const expandedHolders = document.querySelectorAll(
      `${selectors.holder}.${classes.expanded}`,
    );
    if (!expandedHolders.length) return;

    expandedHolders.forEach((holder) => {
      if (holder.contains(event.target)) return;
      collapseInline(holder);
    });
  }

  function onEscapeKey(event) {
    if (event.key !== "Escape") return;

    document
      .querySelectorAll(`${selectors.holder}.${classes.expanded}`)
      .forEach(collapseInline);
  }

  function onProductAdded(event) {
    const button = event.detail?.button;
    if (!button) return;

    const holder = button.closest(`${selectors.holder}.${classes.expanded}`);
    if (!holder || !getInlineScope(holder)) return;

    // Keep the card expanded so the shopper can adjust qty or pick another size.
    holder.classList.remove(classes.loading);
  }

  function onInlineOptionChange(event) {
    const input = event.target;
    if (!input?.matches?.("[data-single-option-selector]")) return;

    const holder = input.closest(`${selectors.holder}.${classes.expanded}`);
    if (!holder || !getInlineScope(holder) || !isProductGridScope(holder)) {
      return;
    }

    const gridItem = holder.closest(selectors.gridItem);
    const variant = getSelectedVariantFromHolder(holder);
    if (gridItem && variant) {
      updateGridItemImage(gridItem, variant, getCheckedColorValue(holder));
    }
  }

  function findExpandedHolder(event) {
    const selector = `${selectors.holder}.${classes.expanded}`;
    const nodes = [event.target, document.activeElement];

    for (const node of nodes) {
      const holder = node?.closest?.(selector);
      if (holder) return holder;
    }

    return null;
  }

  function onVariantChange(event) {
    const holder = findExpandedHolder(event);
    if (!holder || !getInlineScope(holder)) return;

    const variant =
      event.detail?.variant || getSelectedVariantFromHolder(holder);
    if (!variant) return;

    if (isProductGridScope(holder)) {
      const gridItem = holder.closest(selectors.gridItem);
      const priceEl = gridItem?.querySelector("[data-product-price]");
      if (
        priceEl &&
        typeof variant.price === "number" &&
        window.theme?.formatMoney
      ) {
        priceEl.textContent = window.theme.formatMoney(
          variant.price,
          window.theme.moneyFormat,
        );
      }

      updateGridItemImage(gridItem, variant, getCheckedColorValue(holder));
    } else {
      const priceEl =
        holder.querySelector(".product-upsell__price .new-price") ||
        holder.querySelector(".product-upsell__price");
      if (
        priceEl &&
        typeof variant.price === "number" &&
        window.theme?.formatMoney
      ) {
        priceEl.textContent = window.theme.formatMoney(
          variant.price,
          window.theme.moneyFormat,
        );
      }

      const cardImg = holder.querySelector(selectors.cardImage);
      const featured =
        variant.featured_image || variant.featured_media?.preview_image;
      const featuredSrc = resolveFeaturedSrc(featured);
      if (cardImg && featuredSrc) {
        applySrcToImg(cardImg, featuredSrc);
      }
    }

    updateSizeLabels(holder);
  }

  function initInlineQuickAdd() {
    if (document.documentElement.dataset.inlineQuickAddInit === "true") return;
    document.documentElement.dataset.inlineQuickAddInit = "true";

    document.addEventListener("click", onInlineQuickAddClick, true);
    document.addEventListener("click", onSiblingSwapClick, true);
    document.addEventListener("click", onOutsideClick);
    document.addEventListener("keydown", onEscapeKey);
    document.addEventListener("change", onInlineOptionChange);
    document.addEventListener("theme:product:added", onProductAdded);
    document.addEventListener("theme:variant:change", onVariantChange);
  }

  function init() {
    document.querySelectorAll(selectors.cartDrawer).forEach(initTabs);
    initInlineQuickAdd();

    document.addEventListener("theme:product:added", () => {
      document
        .querySelectorAll(selectors.cartDrawer)
        .forEach(syncRecentTabBlocks);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
